import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-wordpress-dev',
  templateUrl: './hire-wordpress-dev.component.html',
  styleUrls: ['./hire-wordpress-dev.component.css']
})
export class HireWordpressDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-wordpress-dev/hire-wordpress-dev.component.ts